import { createSlice } from "@reduxjs/toolkit";
import { ChatListSlice } from "types/chat";
import { fetchChatListThunk } from "./thunk";

const initialState: ChatListSlice = {
    loading: false,
    error: null,
    total: 0,
    filtered_lists: {},
    filters: {page: 1},
    applied_filter_id: null
} 


const chatListSlice = createSlice({
    name: 'chatList',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchChatListThunk.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchChatListThunk.fulfilled, (state, {payload}) => {
                state.loading = false;
                state.error = null;
                const {filterId, filters, chats} = payload;
                const {items, count} = chats;
                const existingList = state.filtered_lists?.[filterId]?.list ?? [];
                const list = filters.page === 1 ? items : [...existingList, ...items];
                state.filtered_lists = {
                    ...state.filtered_lists,
                    [filterId]: {
                        list,
                        page: filters.page,
                        filters,
                        expired: false,
                        last_fetched_at: Date.now(),
                        has_more: count > list.length,
                        count
                    }
                }
                state.applied_filter_id = filterId;
            })
            .addCase(fetchChatListThunk.rejected, (state) => {
                state.loading = false;
            })
    }
})

export default chatListSlice.reducer;